// Texte der Startseite (Home.jsx) — deutsche Übersetzung von fr/home.js.
// Gleiche Schlüssel, gleiche Reihenfolge. Markennamen (Joyful Reveal,
// Mirum Games, Pack Essentiel, Pack Premium) bleiben unübersetzt.
export default {
  'home.seo.titre': 'Joyful Reveal - Gender Reveal Spiel: spielen und das Geschlecht des Babys enthüllen | Mirum Games',
  'home.seo.description': 'Machen Sie aus Ihrer Gender Reveal Party ein Spiel: 2 Teams, lustige Fragen, 11 Puzzleteile zu gewinnen und ein letztes Teil, das das Geschlecht des Babys verrät. Schneller Versand nach Deutschland, Belgien und Frankreich.',

  'home.etat.chargement': 'Wird geladen...',

  'home.vitrine.badge': '🧩 Unsere Kollektion',
  'home.vitrine.description': 'Ein einzigartiges Konzept, das aus der Enthüllung des Babygeschlechts ein lustiges Frage-und-Antwort-Spiel macht! Holen Sie Ihre Liebsten zusammen, bilden Sie Teams und erleben Sie gemeinsam diesen magischen Moment, der Ihnen für immer in Erinnerung bleibt.',
  'home.vitrine.altProduit': 'Joyful Reveal Bärchen - Ökologisches Puzzle, das das Geschlecht des Babys enthüllt - Mirum Games',

  'home.packs.titre': 'Wählen Sie Ihr Pack',
  'home.packs.economisez': 'Sparen Sie {pct} %',
  'home.packs.selectionne': '✓ Ausgewählt',
  'home.packs.selectionner': 'Auswählen',
  'home.packs.voirFiche': '📋 Zur vollständigen Produktseite',

  'home.recap.packChoisi': 'Gewähltes Pack:',
  'home.recap.prixTotal': 'Gesamtpreis:',

  'home.genre.cestPour': 'Das ist für...',
  'home.genre.contenuPack': 'Inhalt des Packs',
  'home.genre.packMixte': 'Gemischtes Pack: Mädchen + Junge inklusive!',
  'home.genre.versionGarcon': 'Version Junge vorausgewählt',
  'home.genre.versionFille': 'Version Mädchen vorausgewählt',

  // Variantenbezeichnungen: dienen den Schaltflächen Junge/Mädchen UND dem
  // zusammengesetzten Produktnamen im Warenkorb (ein Schlüssel pro Variante).
  'home.variante.garcon': 'Junge',
  'home.variante.fille': 'Mädchen',
  'home.variante.mixte': 'Mädchen + Junge',

  'home.cta.ajouterPanier': '🛒 In den Warenkorb',
  'home.cta.voirFichePack': '📋 Zur vollständigen Produktseite von {pack}',
  'home.cta.magique': '✨ Schaffen Sie einen magischen Moment mit Ihrer Familie',

  'home.badges.cleEnMain': 'Startklar',
  'home.badges.pretAOffrir': 'Geschenkfertig',
  'home.badges.livraisonRapide': 'Schneller Versand',

  'home.concept.badge': '✨ Unser einzigartiges Konzept',
  // Sätze rund um die <strong> aufgeteilt: davor / starkes Wort / danach.
  // Achtung: das JSX fügt zwischen den drei Teilen je ein Leerzeichen ein —
  // die Anschlussteile beginnen deshalb nie mit einem Satzzeichen.
  'home.concept.question': 'Ein kleines Mädchen? Ein kleiner Junge?',
  'home.concept.questionSuite': 'Können es alle um Sie herum kaum erwarten zu erfahren, in welches Team Ihr Baby gehört?',
  'home.concept.annonce': 'Verkünden Sie diese Neuigkeit spielerisch und originell — mit unserem Spiel!',
  'home.concept.puzzleAvant': 'Dieses Puzzle ist',
  'home.concept.puzzleMot': 'einzigartig',
  'home.concept.puzzleApres': 'und entsteht Stück für Stück in einem lustigen Frage-und-Antwort-Spiel, um am Ende das kleine Geheimnis des Babys zu verraten.',
  'home.concept.experienceAvant': 'Viel mehr als ein Puzzle: Das hier ist ein',
  'home.concept.experienceMot': 'Erlebnis voller Nähe und Freude',
  'home.concept.experienceApres': 'mit Freunden und Familie. Holen Sie Ihre Liebsten zusammen, bilden Sie Teams und genießen Sie diesen einzigartigen Moment in Ihrem Leben!',
  'home.concept.cadeauAvant': 'Ob Sie selbst werdende Eltern sind oder eine',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': 'für einen lieben Menschen organisieren: Unser Spiel macht dieses Ereignis garantiert noch unvergesslicher.',

  'home.instagram.badge': '📸 Magische Momente',
  'home.instagram.titre': 'Sehen Sie unser Puzzle in Aktion! 🎉',
  'home.instagram.sousTitre': 'Schauen Sie, wie unsere Kundinnen und Kunden ihre magische Enthüllung mit Joyful Reveal erleben',
  'home.instagram.altReel': 'Zwei werdende Eltern umgeben von Puzzleteilen, Illustration Joyful Reveal',
  'home.instagram.voirSur': 'Auf Instagram ansehen',
  'home.instagram.momentTitre': 'Ein unvergesslicher Moment',
  'home.instagram.momentTexte': 'Unsere Puzzles machen aus der Enthüllung ein interaktives und festliches Erlebnis. Legen Sie die Teile gemeinsam mit der Familie und entdecken Sie zusammen das große Geheimnis!',
  'home.instagram.jeuInteractif': 'Interaktives Spiel',
  'home.instagram.enFamille': 'Mit der ganzen Familie',
  'home.instagram.suivezNous': 'Folgen Sie uns auf Instagram',
};
